<template>
<div>
    <!-- Header -->
    <base-header class="pb-6 pb-4 pt-5 pt-md-6 text-center">
        <!-- <h2 class="display-4">DASHBOARD PERAKU</h2> -->
    </base-header>
    &nbsp;
    <!-- Container Utama -->
    <b-container fluid class="">
        <card header-classes="bg-transparent">

            <!-- Maklumat Penjawat Awam -->
            <div>
                <validation-observer v-slot="{ invalid }">
                    <b-form @submit.prevent="SimpanMaklumat">
                        <card header-classes="bg-transparent shadow-sm">
                            <h4 class="mb-0 text-center text-primary font-bold text-13136xl">
                                MAKLUMAT PENDAFTARAN PEGAWAI
                            </h4>
                            <hr />
                            <div class="pl-lg-4">
                                <!-- No. Kad Pengenalan -->
                                <validation-provider name="NoKP" :rules="{ required: true }" v-slot="validationContext">
                                    <b-row class="my-3">
                                        <b-col sm="3" class="font-weight-bold">NO KAD PENGENALAN</b-col>
                                        <b-col sm="1">:</b-col>
                                        <b-col sm="4">
                                            <b-form-input v-model="ProfilAwam.NoKP" class="rounded"></b-form-input>
                                            <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                        </b-col>
                                    </b-row>
                                </validation-provider>

                                <!-- Nama -->
                                <validation-provider name="NAMA" :rules="{ required: true }" v-slot="validationContext">
                                    <b-row class="my-3">
                                        <b-col sm="3" class="font-weight-bold">NAMA </b-col>
                                        <b-col sm="1">:</b-col>
                                        <b-col sm="8">
                                            <b-form-input v-model="ProfilAwam.Nama" :state="getValidationStatePenjawat(validationContext)" class="rounded"></b-form-input>
                                            <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                        </b-col>
                                    </b-row>
                                </validation-provider>

                                <validation-provider name="kategori" :rules="{ required: true }">
                                    <b-row class="my-1">
                                        <b-col lg="3" class="font-weight-bold">KATEGORI * </b-col>
                                        <b-col lg="1">:</b-col>
                                        <b-col lg="4">
                                            <b-form-input v-model="ProfilAwam.kategori"></b-form-input>
                                        </b-col>
                                    </b-row>
                                </validation-provider>

                                <!-- Tarikh Lantikan Pertama -->
                                <validation-provider name="agensi" :rules="{ required: true }">
                                    <b-row class="my-3">
                                        <b-col sm="3" class="font-weight-bold">AGENSI</b-col>
                                        <b-col sm="1">:</b-col>
                                        <b-col sm="4">
                                            <b-form-input v-model="ProfilAwam.agensi" class="rounded shadow-sm"></b-form-input>
                                        </b-col>
                                    </b-row>
                                </validation-provider>

                                <validation-provider name="Klasifikasi Perkhidmatan" :rules="{ required: true }">
                                    <b-row>
                                        <b-col lg="3" class="font-weight-bold"> KLASIFIKASI PERKHIDMATAN AWAM * </b-col>
                                        <b-col lg="1"> :</b-col>
                                        <b-col lg="8">
                                            <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="ProfilAwam.ServClassId" :options="ServClassList" @change="runMethod()" style="width: 50%" aria-describedby="input-2-live-feedback">
                                                <template #first>
                                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-col>
                                    </b-row>
                                </validation-provider>
                                <b-row>
                                    <b-col sm="1">&nbsp;</b-col>
                                </b-row>
                                <validation-provider name="Skim Perkhidmatan" :rules="{ required: true }">
                                    <b-row>
                                        <b-col lg="3" class="font-weight-bold"> SKIM PEKHIDMATAN AWAM * </b-col>
                                        <b-col lg="1"> :</b-col>
                                        <b-col lg="8">
                                            <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="ProfilAwam.SchmOfServId" :options="SchmOfServList" style="width: 80%" aria-describedby="input-2-live-feedback">
                                                <template #first>
                                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-col>
                                    </b-row>
                                </validation-provider>
                                <b-row class="my-1">
                                    <b-col sm="1">&nbsp;</b-col>
                                </b-row>
                                <validation-provider name="pilih skim" :rules="{ required: true }">
                                    <b-row>
                                        <b-col lg="3" class="font-weight-bold"> SSPA ATAU SSM * </b-col>
                                        <b-col lg="1"> :</b-col>
                                        <b-col lg="8">
                                            <b-form-select id="Pilih Skim" name="Pilih Skim" value-field="value" text-field="text" :options="skimOptions" v-model="ProfilAwam.pilihSkim" @change="runMethod2()" style="width: 15%" aria-describedby="input-2-live-feedback">
                                                <template #first>
                                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-col>
                                    </b-row>
                                </validation-provider>
                                <b-row class="my-1">
                                    <b-col sm="1">&nbsp;</b-col>
                                </b-row>
                                <validation-provider name="Gred Jawatan Lantikan Pertama" :rules="{ required: true }">
                                    <b-row class="my-1">
                                        <b-col lg="3" class="font-weight-bold"> GRED JAWATAN* </b-col>
                                        <b-col lg="1">:</b-col>
                                        <b-col lg="8">
                                            <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="ProfilAwam.SalGrdID" :options="SalGrdList" style="width: 40%" aria-describedby="input-2-live-feedback">
                                                <template #first>
                                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-col>
                                    </b-row>
                                </validation-provider>
                                <!-- Tarikh Lantikan Pertama -->
                                <validation-provider name="Tarikh Lantikan Pertama" :rules="{ required: true }">
                                    <b-row class="my-3">
                                        <b-col sm="3" class="font-weight-bold">TARIKH LANTIKAN PERTAMA</b-col>
                                        <b-col sm="1">:</b-col>
                                        <b-col sm="4">
                                            <b-form-input type="date" v-model="ProfilAwam.DtLantikanPertama" class="rounded shadow-sm"></b-form-input>
                                        </b-col>
                                    </b-row>
                                </validation-provider>
                                <validation-provider name="Gred Jawatan Lantikan Pertama" :rules="{ required: true }">
                                    <b-row class="my-1">
                                        <b-col lg="3" class="font-weight-bold"> PEGAWAI PENGIRA * </b-col>
                                        <b-col lg="1">:</b-col>
                                        <b-col lg="8">
                                            <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="ProfilAwam.pegPengira" :options="pegPengiraList" style="width: 40%" aria-describedby="input-2-live-feedback">
                                                <template #first>
                                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-col>
                                    </b-row>
                                </validation-provider>
                            </div>

                            <!-- Butang Simpan -->
                            <b-row class="justify-content-center mt-4">
                                <b-button variant="success" type="submit" :disabled="invalid" class="px-5">SIMPAN</b-button>
                            </b-row>
                        </card>
                    </b-form>
                </validation-observer>
            </div>
        </card>
    </b-container>
</div>
</template>

<script>
import moment from "moment";
import Store from "@/store";
import GetselenggaraService from "@/services/selenggaraService.js";
import GetsalaryService from "@/services/salaryService.js";
import swal from "sweetalert2";
export default {
    data() {
        return {

            ProfilAwam: {
                //StatusKGT2023: 1,
                // Nama: null,
            },
            skimOptions: [{
                    value: '2',
                    text: 'SSPA'
                },
                {
                    value: '1',
                    text: 'SSM'
                },
            ],
            ServClassList: [],
            SchmOfServList: [],
            SalGrdList: [],
            pegPengiraList: [{
                    value: 1,
                    text: "ABU",
                },
                {
                    value: 2,
                    text: "ALI",
                },
            ],

        };
    },
    methods: {
        getValidationStatePenjawat({
            dirty,
            validated,
            valid = null
        }) {
            return dirty || validated ? valid : null;
        },
        runMethod() {
            console.log("klas perkhidmatan", this.ServClassId);

            let Search = {
                ServClassId: this.ProfilAwam.ServClassId,
            };

            GetselenggaraService.getSenaraiSchmOfServ(Search)
                .then((resp) => {
                    this.SchmOfServList = resp.data;
                    //console.log(this.objekList);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        runMethod2() {

            let Search = {
                ServClassId: this.ProfilAwam.ServClassId,
                SchmOfServId: this.ProfilAwam.SchmOfServId,
                pilihSkim: this.ProfilAwam.pilihSkim,
            };

            console.log("search", Search);

            GetselenggaraService.getSenaraiSalGrd(Search)
                .then((resp) => {
                    this.SalGrdList = resp.data;
                    //console.log(this.objekList);
                })
                .catch((err) => {
                    console.log(err);
                });
        },

    },
    created() {
        GetselenggaraService.getSenaraiServClass()
            .then((resp) => {
                this.ServClassList = resp.data;
                //console.log("SERVE",this.ServClassList);
            })
            .catch((err) => {
                console.log(err);
            });

        // GetselenggaraService.getSenaraiSchmOfServ()
        //     .then((resp) => {
        //         this.SchmOfServList = resp.data;
        //         //console.log(this.objekList);
        //     })
        //     .catch((err) => {
        //         console.log(err);
        //     });

        // GetselenggaraService.getSenaraiSalGrd()
        //     .then((resp) => {
        //         this.SalGrdList = resp.data;
        //         //console.log(this.objekList);
        //     })
        //     .catch((err) => {
        //         console.log(err);
        //     });

    },
};
</script>

<style scoped>
/* Optional: Customize styles for better aesthetics */
h4 {
    font-weight: 600;
    text-transform: uppercase;
}

.stats-card2 {
    transition: transform 0.3s;
}

.stats-card2:hover {
    transform: scale(1.05);
    /* Scale up on hover */
}

.base-button {
    transition: background-color 0.3s;
}

.base-button:hover {
    background-color: rgba(255, 255, 255, 0.1);
    /* Slight change on hover */
}
</style>
